{
  "slug": "how-is-iq-measured",
  "title": "IQ कैसे मापा जाता है?",
  "description": "मानकीकृत आईक्यू परीक्षण, आयु-आधारित मानदंड, उप-परीक्षाएं, प्रतिशतांक, और हर परिणाम के लिए त्रुटि का एक सीमा है क्यों समझें।",
  "summary": "IQ को मानकीकृत संज्ञानात्मक कार्यों के साथ मापा जाता है. कच्चे प्रदर्शन की तुलना आयु-आधारित मानकों से की जाती है और एक स्कोर में बदल दिया जाता है, आमतौर पर केंद्रित  पर 100.",
  "sections": [
    {
      "heading": "कार्यों से एक मानकीकृत स्कोर",
      "paragraphs": [
        "एक मूल्यांकन में कई उप-परीक्षाएँ होती हैं. एक व्यक्ति पैटर्न पहचान सकता है, स्मृति में जानकारी में हेरफेर कर सकता है, मौखिक समस्याओं को हल कर सकता है, या समय सीमा के भीतर सटीक रूप से काम कर सकता है. रॉ कुलों का अकेले में बहुत कम अर्थ होता है, इसलिए प्रकाशक उन्हें बड़े संदर्भ नमूने के साथ तुलना करते हैं.",
        "प्रदर्शन की तुलना उसी आयु समूह के लोगों से की जाती है. मापे गए उप-परीक्षा स्कोर को व्यापक सूचकांक स्कोर और एक समग्र अनुमान में जोड़ा जा सकता है।"
      ]
    },
    {
      "heading": "नॉर्म्स, प्रतिशत, तथा फैलाव",
      "paragraphs": [
        "कई वर्तमान परीक्षणों का उपयोग करें 100 और एक मानक विचलन 15. एक प्रतिशत स्थिति को व्यक्त करता है: 100 के पास है 50100वां प्रतिशत, जबकि 120 के आसपास है 91सामान्य वितरण के अंतर्गत st प्रतिशत",
        "विभिन्न उपकरणों में विभिन्न कार्य और मानदंडों का उपयोग होता है, इसलिए दो वैध परीक्षण हमेशा समान स्कोर नहीं देते हैं।"
      ]
    },
    {
      "heading": "क्यों है यह महत्वपूर्ण?",
      "paragraphs": [
        "प्रत्येक स्कोर में माप अनिश्चितता शामिल है और आमतौर पर एक विश्वसनीय अंतराल के साथ रिपोर्ट किया जाना चाहिए. एक प्रशिक्षित परीक्षार्थी उप-परीक्षा पैटर्न, भाषा, सांस्कृतिक पृष्ठभूमि, परीक्षण की स्थिति और मूल्यांकन के उद्देश्य पर भी विचार करता है।",
        "अच्छा माप मानक निर्देशों, उपयुक्त मानकों, परीक्षण सुरक्षा, विश्वसनीयता तथा वैधता पर निर्भर करता है. इस संदर्भ के बिना संख्या भ्रमित कर सकती है."
      ]
    }
  ],
  "faqs": [
    {
      "question": "कुछ IQ कार्यों को समयबद्ध क्यों किया जाता है?",
      "answer": "कुछ उपपरीक्षाएँ प्रसंस्करण दक्षता को मापती हैं, परन्तु अनेक तर्क कार्यों में समय नहीं होता है या उनके पास बहुत सीमित सीमाएँ होती हैं. समय एक मूल्यांकन का केवल एक भाग है."
    },
    {
      "question": "विभिन्न IQ परीक्षण अलग-अलग परिणाम दे सकते हैं?",
      "answer": "हाँ. सामग्री, मानक, माप त्रुटि, स्वास्थ्य, और परीक्षण परिस्थितियों के कारण उचित अंतर हो सकता है."
    }
  ],
  "related": ["what-is-iq", "what-is-the-average-iq", "iq-score-ranges-explained"]
}
